
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
const cn = {
  config: '配置',
  manage: '管理',
  ...zhLocale
}

export default cn;
